import {
    AbstractPmsApiService
} from "./abstract.service";
import {
    ReservationNote
} from "../models";

export class ReservationNotePmsApiService extends AbstractPmsApiService {

    get urlPattern() {

        return '/reservation/:reservationId/note(/:id)';
    }

    newModel(attributes, ...params) {

        return new ReservationNote(attributes);
    }

    get(params, reservation) {

        const url = this.url({
            reservationId: reservation.id
        });

        return this.http.get(url, {
                headers: this.authHeaders,
                params
            }).then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    create(note, reservation) {

        const url = this.url({
            reservationId: reservation.id,
        });

        return this.http.post(url, note.toObjectExcept('reservation', 'user'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    update(note, reservation) {
        const url = this.url({
            reservationId: reservation.id,
            id: note.id
        });

        return this.http.put(url, note.toObjectExcept('reservation', 'user'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    delete(note) {
        const url = this.url({
            reservationId: note.reservation.id,
            id: note.id
        });

        return this.http.delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/reservation-note.service.js